"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetFunctionalNameRequirementResultMetadataSchema = exports.NetFunctionalNameRequirementInstanceMetadataSchema = exports.NetFunctionalNameRequirementResultTypeName = exports.NetFunctionalNameValidationResultKey = exports.NetFunctionalNameValidationRequirementTypeId = void 0;
const zod_1 = require("zod");
const IInsightError_1 = require("../../IInsightError");
exports.NetFunctionalNameValidationRequirementTypeId = 'NetFunctionalName';
exports.NetFunctionalNameValidationResultKey = 'NetFunctionalNameValidationResult';
exports.NetFunctionalNameRequirementResultTypeName = 'NetFunctionalNameResult';
exports.NetFunctionalNameRequirementInstanceMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.NetFunctionalNameValidationResultKey),
    netName: zod_1.z.string(),
});
exports.NetFunctionalNameRequirementResultMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.NetFunctionalNameRequirementResultTypeName),
    insights: zod_1.z.lazy(() => IInsightError_1.IInsightErrorSchema).array(),
});
//# sourceMappingURL=NetFunctionalNameRequirement.js.map